<template>
  <div
    class="flex flex-column"
    style="justify-content: center; align-items: center; height: 100%"
  >
    <img src="../img/IdCard.png" style="width: 2.4rem; height: 2.4rem" />
    <p style="font-size: 0.7rem; font-weight: bold">请读取司机身份证</p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      vehicle: this.$route.query.vehicle || {}
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted: function () {
    //开启NFC模块
    if (window.framework.isReadCard) {
      window.framework.isReadCard(true);
    }
    var fun = function (jsonObj) {
      if (!jsonObj.type) {
        this.checkMode = "手持机刷卡";
      } else {
        this.checkMode = jsonObj.type;
      }
      //读取失败
      if (!jsonObj.success) {
        this.$toast.fail("身份证读取失败！");
        return;
      }
      let isDrive = false;
      if (
        this.vehicle.Driver1CertNo === jsonObj.data.身份号码 &&
        jsonObj.data.姓名 === this.vehicle.Driver1Name
      ) {
        isDrive = true;
      }
      if (
        !isDrive &&
        this.vehicle.Driver2CertNo === jsonObj.data.身份号码 &&
        jsonObj.data.姓名 === this.vehicle.Driver2Name
      ) {
        isDrive = true;
      }
      if (!isDrive) {
        this.$toast.fail("该身份信息与司机信息不一致");
      } else {
        this.$toast("身份信息验证成功");
      }
      // //判断检票 或 订票更新实名信息
      // if (this.showTicketInfo && this.ticket) {
      //   let info = {
      //     CustName: this.CardInfo["姓名"],
      //     CustCertNo: this.CardInfo["身份号码"],
      //     CustCertType: "居民身份证",
      //     IsChild: this.checkCardInfo.IsChild,
      //     TicketPrice: this.checkCardInfo.TicketPrice,
      //     TicketTypeID: this.checkCardInfo.TicketTypeID,
      //     Remark: this.checkCardInfo.Remark,
      //   };
      //   if (this.ticket.TicketStatusID == 2) {
      //     //检票查看票信息时更新实名信息
      //     this.onUpdateRealName(this.ticket, info, "check");
      //     return;
      //   } else if (this.ticket.TicketStatusID == 4) {
      //     //订票查看票信息时更新实名信息
      //     this.onUpdateRealName(this.ticket, info, "book");
      //     return;
      //   } else {
      //     this.$toast.fail("已检的票请先退检再更新实名信息!");
      //     return;
      //   }
      // } else {
      //   //检票情况
      //   this.onCheckByIdNumber(this.CardInfo["身份号码"]);
      // }
    };

    // var nfcFun = function (ReqId, AndroidID) {
    //   this.isNFC = true;
    //   this.checkMode = "nfc刷卡";
    //   //读取失败
    //   if (!ReqId) {
    //     this.playWav("err");
    //     this.$toast.fail("身份证读取失败！");
    //     return;
    //   }
    //   this.playWav("nfc");
    //   //调动后端接口获取身份信息
    //   this.$http
    //     .post(
    //       this.$api.getIdCardCloudDecode,
    //       this.$qs.stringify({ ReqId: ReqId, AndroidID: AndroidID })
    //     )
    //     .then((res) => {
    //       if (res.success) {
    //         //alert(JSON.stringify(res.data))
    //         //将身份信息转为CardInfo对象  暂时只有两项信息 号码及姓名；返回图片会导致服务器加解密时间过长。
    //         let jsonObj = {
    //           success: res.success,
    //           data: {
    //             姓名: res.data.Name,
    //             身份号码: res.data.IdNum,
    //             照片: res.data.Picture,
    //             性别: res.data.Sex,
    //             民族: res.data.Nation,
    //             出生日期: res.data.BirthDate
    //               ? this.$moment(res.data.BirthDate).format("YYYY-MM-DD")
    //               : null, //格式化
    //             地址: res.data.Address,
    //           },
    //           type: "nfc刷卡",
    //         };
    //         fun.bind(this)(jsonObj);
    //       }
    //     });
    // };
    // //NFC读取身份证
    // window.callJSIdCardCloudDecode = nfcFun.bind(this);
    //读取身份证回调
    window.callJSPersonInfo = fun.bind(this);
  },
  created() {},
  destroyed() {},
};
</script>

<style scoped lang="less">
.LineClassPicker {
  width: 95%;
  margin: 10px auto;
  text-align: -webkit-auto;
}
.date-content {
  line-height: 46px;
  font-size: 0.32rem;
  background-color: #fff;
  margin-bottom: 0.15rem;
}

.date-content .date-content-date {
  width: 50%;
  text-align: center;
  float: left;
  font-size: 0.35rem;
  font-weight: 600;
}

.date-content .date-content-left {
  float: left;
  padding-left: 5%;
}

.date-content .date-content-right {
  text-align: right;
  float: right;
  padding-right: 5%;
}
.infoValue {
  font-size: 16px;
  color: #323233;
}
.sendCarBtn {
  color: white;
  border: 0;
}
.van-step {
  color: black;
}
.vecar {
  margin: 0px auto;
  margin-bottom: 10px;
}
.checkIn {
  margin-top: 5px;
}
.step-car-div {
  margin-top: 27px;
  font-size: 16px;
  margin-bottom: 27px;
}
.step-car {
  min-height: 30px;
}
.setps-icon {
  float: left;
}
.setps {
  width: 95%;
  margin: 0 auto;
  text-align: initial;
}

.siteContentBox {
  border: 0.0625rem solid;
  border-radius: 0.15625rem;
  overflow: hidden;
}
.siteContentBox .van-cell-group .van-cell {
  border-bottom: 0.03125rem solid #ccc;
}
.siteContentBox .van-cell-group .van-cell .van-icon {
  font-size: 0.5rem;
}
.siteContentBox .van-cell-group .van-cell {
  font-size: 0.5rem;
}
.sendCarState {
  font-size: 0.5rem;
  padding: 0.3125rem 0.46875rem;
  border-bottom: 0.03125rem solid #ccc;
}

.vehicleBox {
  border: 0.03125rem solid;
  padding: 0.3125rem 0.3125rem 0 0.3125rem;
}
.vehicleBox div {
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.vehicleBox .van-icon {
  line-height: 0.8rem;
  color: #ccc;
}
.vehicleBox .van-panel__footer {
  display: flex;
  justify-content: space-between;
}
.vehicleBox .footer {
  overflow: hidden;
  width: 100%;
}
.vehicleBox .footer .van-row {
  width: 100%;
}
.van-cell__label {
  font-size: 16px;
  color: #323233;
}
.van-picker__cancel,
.van-picker__confirm {
  height: 100%;
  padding: 0 0.1rem;
  font-size: 0.4375rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
</style>
